<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>灌浆类型：</label>
                        <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="grade==4"></Btns>
                    <Btns :menu_id="menu_id" :menus="main_btns" :ignore_ids="',3211,'" @on_btnclk="btnClick" v-else></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom" width="80"></el-table-column>
                        <el-table-column label="操作" width="280" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    :pid="pid"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看灌浆孔"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Import
                    width="600px"
                    title="导入检查孔"
                    :isshow="importshow"
                    @on-close="closeImportDialog"
                    @on-imp-ok="impOk">
                </Import>
                <AnnexList
                    width="600px"
                    :data_id="model_id"
                    :isshow="annexshow"
                    @on-close="closeAnnexDialog">
                </AnnexList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Import from "./import"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import AnnexList from "./annexlist"

export default {
    name: 'workHoleCheckList',
    mixins: [listutil],
    components: {Edit, Info, Import, Btns, LabBtns, AnnexList},
    data() {
        return {
            m_name: '灌浆检查孔',
            menu_id: 3210,
            list_url: "/api/admin/workholecheck/list",
            search_Obj: {
                f_hole_code: '',
            },
            del_Obj:{
                url:'/api/admin/workholecheck/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            importshow: false,
            annexshow: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        },
        annexSet(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
    }
};
</script>